import React, { createContext, useContext, useState } from 'react'
import QrScanner from "react-qr-scanner";
import { UiItemContext } from '../../../cnr/contexts/UiItemContext'
import FullPageWrapper from '../../../wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper'

export const QrScanContext = createContext();

const QrScan = (props) => {

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_handlers } = uiItemContext ?? {}

  const [scannedData, setScannedData] = useState()

  const handleCancel = () => {
    if (props.handleCancel) {
      props.handleCancel()
    } else if (item_handlers.handleShow_itemSidebar) {
      item_handlers.handleShow_itemSidebar()
    }
  }

  const handleError = err => console.error(err)

  const handleScan = (_scannedData) => {
    const text = _scannedData?.text;
    if (!text) return;

    try {
      // Try to decode if it’s base64-encoded JSON
      const decoded = atob(text);
      const parsed = JSON.parse(decoded);
      setScannedData(parsed);
      props.handleScannedData?.(parsed);
    } catch {
      try {
        // Or maybe it was plain JSON
        const parsed = JSON.parse(text);
        setScannedData(parsed);
        props.handleScannedData?.(parsed);
      } catch {
        // Otherwise, just return raw text
        setScannedData({ rawText: text });
        props.handleScannedData?.({ rawText: text });
      }
    }
  }

  const qrReader = () => {
    const previewStyle = { width: "100%", };

    return (
      <QrScanner
        delay={300}                     // same as your old delay
        style={previewStyle}            // styling
        onError={handleError}           // handle errors
        onScan={handleScan}             // handle successful scans 
        constraints={{
          video: { facingMode: 'environment' }, // 👈 forces rear camera
        }}
        className="test"
      />
    );
  };

  const content = () => {
    if (scannedData) {
      return <QrScanContext.Provider value={{ qrScan_state: { scannedData: scannedData } }} >
        <div>{JSON.stringify(scannedData)}</div>
      </QrScanContext.Provider >
    } else {
      return qrReader(128)
    }
  }

  const wrapper = () => <Wrapper
    content={content()}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'qr-container scan' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'QR Scan'}
    wrapperCss={{ container: 'app-dark-mode' }}
  />

  return fullPageWrapper()
}

export default QrScan